import React from "react";
// import Waypoint from "react-waypoint";
import AnimateEffect from "../../tool/animateEffect";
// import { Button } from 'react';
// import { Navigator , MobileNav } from "./nav";
// import { PrivacyPolicyEnglish } from "./privacyPolicy_en_us.js"
import { IndexFooter } from "./../index/indexFooter.js"
import downloadPic from "../../../images/icon/maidwhiteDownload.png";
import { StringHelper, _ } from '../../strings'

export default class Invitation extends React.Component {
  constructor(props) {
    super(props);
    console.log(props)
    this.state = {
      landingWaypoint: false,
      navFix: true,
      lang_code: props.match.params.lang_code,
      home_id: props.match.params.home_id,
      invite_code: props.match.params.invite_code,
    };

    console.log("strings")
    console.log(StringHelper)
    console.log("lang: ", props.match.params.lang_code);
    StringHelper.setDefaultLoacle(props.match.params.lang_code);
  }
  componentDidMount() {
    console.log("componentDidMount");
    setTimeout(function(){ window.scrollTo(0,0); }, 10);
      // if (this.props.location !== prevProps.location) {

      // }
  }

  getStringTable(code) {
    var table = {}
    table["zh-tw"] = {
      "help_tex1": "請開啟 Maid White<br/>以繼續執行步驟",
      "button_text_open_maidwhite": "開啟 Maid White",
      "button_text_download_maidwhite": "帶 Maid White 回家",
    }
    table["zh"] = {
      "help_tex1": "請開啟 Maid White<br/>以繼續執行步驟",
      "button_text_open_maidwhite": "開啟 Maid White",
      "button_text_download_maidwhite": "帶 Maid White 回家",
    }
    table["en"] = {
      "help_tex1": "Please open Maid White<br/>to continue the steps",
      "button_text_open_maidwhite": "Open Maid White",
      "button_text_download_maidwhite": "Get Maid White",
    }
    table["ja"] = {
      "help_tex1": "メイドホワイトを開けて<br/>手順を続行してください" ,
      "button_text_open_maidwhite": "アプリを開く",
      "button_text_download_maidwhite": "ダウンロード",
    }



    if(typeof(table[code]) == "undefined"){
      return table["en"] // fall back
    }
    return table[code]
  }

  getMaidwhiteDeepLink() {
    return "maidwhite://homes/" + this.state.home_id + "/invitations/" + this.state.invite_code

  }

  getAppDownloadLink() {
    const link = "https://www.tih.tw/get-maidwhite-app"
    const encodedDeepLink = encodeURIComponent(this.getMaidwhiteDeepLink())
    return link + "?referrer=" + encodedDeepLink

  }

	render() {
    const s = this.getStringTable(this.state.lang_code)
    const {
      landingWaypoint,
      navFix
    } = this.state;
    return (
       <div className="invitation">
         <div>
          <div className="help-text" dangerouslySetInnerHTML={{__html: s.help_tex1}} />
          <div className="help-image">
            <img src={downloadPic} />
          </div>   
          <a href={this.getMaidwhiteDeepLink()}>
            <div className="button button-1">
            {s.button_text_open_maidwhite}
            </div>   
          </a>
          <a href={this.getAppDownloadLink()}>
            <div className="button button-2">
            {s.button_text_download_maidwhite}
            </div>
          </a>
        </div>

       {/* <Navigator onTop={navFix} />*/ }
        {/* <!-- <MobileNav /> -->*/}
        {/*<PrivacyPolicyEnglish />
        <Waypoint onEnter={()=>{navFix&&this.setState({navFix: false})}} />
        */ }
        <IndexFooter />
      </div>
    );

  }
}
